import React, { FC, useState } from 'react';
import { AdjustFrame } from '../../components/adjust-frame';
import config from '../../config/path';
import { SpinnerWrapper } from '../../components/spinner-wrapper';
import { useUser } from '../../hooks/useUser';
import styles from './preliminary-application-wp-new.module.scss';

export const PreliminaryApplicationWpNew: FC = () => {
    const { token, refreshToken, isLoading, error, handleIframeLoad } =
        useUser();

    if (error) {
        return <div>{error.message}</div>;
    }

    const iframeUrl = `${config.PRICE_DEC_API}/application-ovl/iframe?token=${token}&refreshToken=${refreshToken}`;
    const allowedOrigin = (() => {
        try {
            return new URL(config.PRICE_DEC_API).origin;
        } catch {
            return undefined;
        }
    })();

    return (
        <div className={styles.iframeContainer}>
            {isLoading && (
                <div className={styles.spinnerOverlay}>
                    <SpinnerWrapper size="default" spinning={isLoading} />
                </div>
            )}
            {iframeUrl && (
                <AdjustFrame
                    key={iframeUrl}
                    src={iframeUrl}
                    allowedOrigin={allowedOrigin}
                    expectedMessageType="IFRAME_SIZE"
                    requestType="REQUEST_IFRAME_SIZE"
                    fallbackMode="fixed"
                    viewportOffset={103}
                    initialHeight={600}
                    minHeight={300}
                    debounceMs={80}
                    style={{ width: '100%' }}
                    onLoad={handleIframeLoad}
                />
            )}
        </div>
    );
};
